import { ArrowForward, Article } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { LocationFormField } from "./LocationFormField";

export const LocationInfo = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Article style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Information")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <LocationFormField label={t("LocationCode")} type="text" code="LocationCode" data={dataState} setData={setDataState} />
            <LocationFormField label={t("LocationName")} type="text" code="LocationName" data={dataState} setData={setDataState} />
            <LocationFormField label={t("LocationComments")} type="text" code="Comments" data={dataState} setData={setDataState} />
            <LocationFormField label={t("Country")} type="foreignKey" entity="Country" filterField={'Name'} labelFields={['Name']} extraFields={[{key: 'Id', value: 'CountryId'}, {key: 'Name', value: 'CountryName'}]} code="CountryName" data={dataState} setData={setDataState} />
            <LocationFormField label={t("Account")} type="foreignKey" entity="Account" filterField={'AccountCode'} labelFields={['AccountCode']} extraFields={[{key: 'Id', value: 'AccountId'}, {key: 'AccountCode', value: 'AccountCode'}]} code="AccountCode" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}